import { API_PREFIX, Request } from "./request";

export interface LoginParams {
  username: string;
  password: string;
}

export function login(params: LoginParams): Request {
  return {
    url: `${API_PREFIX}/auth/token`,
    method: "POST",
    params,
  };
}

export function ssoLogin(params: string): Request {
  return {
    url: `${API_PREFIX}/auth/from/third`,
    method: "POST",
    body: {
      accessToken: params,
    },
  };
}
